export default "__VITE_ASSET__D3pWK0ci__"